import { render } from "./SubcourseList.vue?vue&type=template&id=3ede5fef"
import script from "./SubcourseList.vue?vue&type=script&lang=js"
export * from "./SubcourseList.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__